export const base = 'importrfv';

export const getPresignedUrl = `${base}/pre-signed-url`;
export const getFileRfv = `${base}/file-rfv`;
export const postLogo = `${base}`;
